<div class="chart-container" style="position: relative; width: 100%; height: 100%;">
  <canvas [id]="canvasId" class="mt-4 mx-2">{{chart}}</canvas>
</div>
